export enum DeviceFilterEnum {
  AllDevices = 'all',
  Mobile = 'mobile',
  Desktop = 'desktop',
  Tablet = 'tablet',
  Unknown = 'unknown',
}
